import React from "react";

const RLCloudSandboxLabel = () => (
  <span className="integrations__rl-cloud-sandbox-label">
    <img src="/static/images/rl-logo-square.svg" /> Cloud Sandbox
  </span>
);

RLCloudSandboxLabel.toString = () => "RL Cloud Sandbox";

export default RLCloudSandboxLabel;
